import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=71caa0d3&scoped=true"
import script from "./Swiper.js?vue&type=script&lang=js&external"
export * from "./Swiper.js?vue&type=script&lang=js&external"
import style0 from "./Swiper.scss?vue&type=style&index=0&id=71caa0d3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71caa0d3",
  null
  
)

export default component.exports